import { FlagStatus, STATUS } from '@hivebrite/design-system/Flag';

const EventCanceledLabel = ({ event: { cancelled = false } }) => {
  if (!cancelled) {
    return null;
  }

  return <FlagStatus status={STATUS.ERROR} text={__('Canceled')} />;
};

export default EventCanceledLabel;
